module.exports = __webpack_public_path__ + "static/img/ecom-01.0b9b0dce.jpg";